import Vue from 'vue'
import Clipboard from 'clipboard'

import i18n from '../i18n'

function clipboardSuccess () {
  Vue.prototype.$message.success(i18n.translate('message.copySuccess'))
}

function clipboardError () {
  Vue.prototype.$message.error(i18n.translate('message.copyFailed'))
}

export default function handleClipboard (text, event) {
  const clipboard = new Clipboard(event.target, {
    text: () => text
  })
  clipboard.on('success', () => {
    clipboardSuccess()
    clipboard.destroy()
  })
  clipboard.on('error', () => {
    clipboardError()
    clipboard.destroy()
  })
  clipboard.onClick(event)
}



// WEBPACK FOOTER //
// ./src/utils/clipboard.js